import type { UnlikelyMoney, UnlikelyVariant } from "@unlikelystudio/commerce-connector"

export function processCompareAtPrice(variant: UnlikelyVariant): UnlikelyMoney | null {
  if (!variant || !variant.compareAtPrice) return null
  return variant?.price?.amount !== variant?.compareAtPrice.amount ? variant?.compareAtPrice : null
}
